export class ModalManager {
    constructor() {
        this.modalElement = null;
        this.modalContentElement = null;
        this.modalContentWrapperElement = null;
        this.modalCloseElement = null;
        this.selector = null;
        this.create();
    }
    create() {
        if (!this.modalElement) {
            this.modalElement = document.createElement('div');
            this.modalContentElement = document.createElement('div');
            this.modalCloseElement = document.createElement('span');
            this.modalElement.classList.add('pgb-image-popup-modal');
            this.modalContentElement.classList.add('pgb-image-popup-modal-content');
            this.modalCloseElement.classList.add('pgb-image-popup-close');
            this.modalCloseElement.innerHTML = '&times;';
            this.modalContentElement.appendChild(this.modalCloseElement);
            this.modalElement.appendChild(this.modalContentElement);
            document.body.appendChild(this.modalElement);
            this.registerEvents();
        }
    }
    registerEvents() {
        this.modalElement.addEventListener('click', this.close.bind(this));
        this.modalCloseElement.addEventListener('click', this.close.bind(this));
    }
    close(event) {
        if (!this.modalContentWrapperElement.contains(event.target)) {
            event.preventDefault();
            event.stopPropagation();
            return new Promise((resolve, reject) => {
                try {
                    this.modalElement.style.display = 'none';
                    this.resetContent();
                    this.removeSelector();
                    resolve();
                }
                catch (e) {
                    reject(e);
                }
            });
        }
    }
    open() {
        return new Promise((resolve, reject) => {
            try {
                this.create();
                this.modalElement.style.display = 'block';
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    }
    addSelector(selector) {
        this.selector = selector;
        this.modalElement.classList.add(this.selector);
    }
    removeSelector() {
        if (this.selector) {
            this.modalElement.classList.remove(this.selector);
            this.selector = '';
        }
    }
    setContent(html = 'no content available') {
        this.resetContent();
        this.modalContentWrapperElement = document.createElement('div');
        this.modalContentWrapperElement.classList.add('content-wrapper');
        this.modalContentWrapperElement.innerHTML = html;
        this.modalContentElement.appendChild(this.modalContentWrapperElement);
    }
    appendContent(element) {
        this.resetContent();
        this.modalContentWrapperElement = element;
        this.modalContentElement.appendChild(this.modalContentWrapperElement);
    }
    resetContent() {
        if (this.modalContentWrapperElement) {
            this.modalContentElement.removeChild(this.modalContentWrapperElement);
            this.modalContentWrapperElement = null;
        }
    }
    getModalElement() {
        return this.modalElement;
    }
}
